module.exports = __webpack_public_path__ + "img/logo_landscape.0441780a.png";